export class PasswordMustMatchValidationError {
  public readonly error = true;
}
